<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <form (ngSubmit)="onClickSaveAndClose()" [formGroup]="formGroup" appInvalidControlScroll
          [scrollContainer]="scrollContainer">

        <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <div class="title dialog-title">
                    <ng-container *ngIf="formGroup.get('orderTitle').value as orderTitle; else newOrderTitle">
                        {{ 'workflows.screens.dockSiteOrder.toolbarTitleWithName' | translate: { name: orderTitle } }}
                    </ng-container>
                    <ng-template #newOrderTitle>{{ 'workflows.screens.dockSiteOrder.toolbarTitleNew' | translate }}</ng-template>
                </div>
                <button data-test="B-Close-dialog" mat-icon-button (click)="onClickClose()"
                        [attr.aria-label]="'common.closeDialogAria' | translate" type="button">
                    <mat-icon>close</mat-icon>
                </button>
    </mat-toolbar>

        <div mat-dialog-content #scrollContainer>

            <mat-form-field class="example-full-width" appearance="fill">
                <mat-label>{{ 'workflows.screens.dockSiteOrder.orderTitleLabel' | translate }}</mat-label>
                <input formControlName="orderTitle" type="text" matInput
                       [placeholder]="'workflows.screens.dockSiteOrder.orderTitlePlaceholder' | translate">
                <mat-error>{{formGroup.get('orderTitle').errors | firstErrorMessage}}</mat-error>
            </mat-form-field>

            <mat-accordion class="example-headers-align">

                <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" hideToggle>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ 'workflows.screens.dockSiteOrder.panelClient' | translate }}
                        </mat-panel-title>
                        <mat-panel-description [ngClass]="selectedPerson?.firstName ? 'bold' : ''">
                            <span fxHide.lt-sm>{{ personString || ('workflows.screens.dockSiteOrder.clientHint' | translate) }}</span>
                            <mat-icon [color]="this.personString ? 'accent' : 'primary'">account_circle</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <ng-container
                            *ngIf="formGroupPrepare.get('type').touched && formGroupPrepare.get('type').errors">
                        <u2b-message type="warning">
                            {{formGroupPrepare.get('type').errors | firstErrorMessage}}
                        </u2b-message>
                    </ng-container>

                    <div [formGroup]="formGroupPrepare">
                        <mat-radio-group class="radio-group-inline" formControlName="type">
                            <mat-radio-button [value]="'person'">{{ 'person.singular' | translate }}</mat-radio-button>
                            <mat-radio-button [value]="'organisation'">{{ 'company.singular' | translate }}</mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <ng-container *ngIf="formGroupPrepare.get('type').value === 'person'">
                        <mat-divider class="special-divider"></mat-divider>
                        <form-widget-person [person$]="person$"
                                            [optionalFields]="true"></form-widget-person>
                    </ng-container>

                    <ng-container *ngIf="formGroupPrepare.get('type').value === 'organisation'">
                        <mat-divider class="special-divider"></mat-divider>
                        <form-widget-company [company$]="company$"
                                             [optionalFields]="true"></form-widget-company>
                    </ng-container>
                </mat-expansion-panel>

                <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)" hideToggle>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ 'workflows.screens.dockSiteOrder.panelPeriod' | translate }}
                        </mat-panel-title>
                        <mat-panel-description>
                            <span fxHide.lt-sm>
                                {{ selectedStartTime || ('workflows.screens.dockSiteOrder.periodHint' | translate) }}
                                <br>
                                {{ selectedEndTime || '' }}
                           </span>
                            <mat-icon
                                    [color]="this.selectedStartTime || this.selectedEndTime ? 'accent' : 'primary'">
                                add_alarm
                            </mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <form-widget-date-range [from]="this.data?.order?.startTime" [to]="this.data?.order?.endTime"
                                            [headline]="null"
                                            [parentFormGroup]="formGroup"></form-widget-date-range>
                </mat-expansion-panel>

                <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)" hideToggle>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{'boats.singular' | translate}}
                        </mat-panel-title>
                        <mat-panel-description [ngClass]="selectedBoat?.name ? 'bold' : ''">
                            <span fxHide.lt-sm>{{ boatString || ('workflows.screens.dockSiteOrder.boatHint' | translate: { boatLabel: ('boats.singular' | translate) }) }}</span>
                            <mat-icon [color]="this.boatString ? 'accent' : 'primary'">directions_boat</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div fxLayout="column" fxLayoutGap="24px">
                        <ng-container>
                            <form-widget-boat [givenBoats]="this.givenBoats"></form-widget-boat>
                        </ng-container>
                    </div>
                </mat-expansion-panel>

                <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)" hideToggle>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ 'workflows.screens.dockSiteOrder.panelStatus' | translate }}
                        </mat-panel-title>
                        <mat-panel-description>
                            <span fxHide.lt-sm>{{ (formGroup.get('status').value | translate) || ('workflows.screens.dockSiteOrder.statusHint' | translate) }}</span>
                            <mat-icon [color]="this.formGroup.get('status').value ? 'accent' : 'primary'">timelapse
                            </mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div fxLayout="row" fxLayoutAlign="start start" class="mb-24">
                        <mat-form-field fxFlex>
                            <mat-label>{{ 'workflows.screens.dockSiteOrder.panelStatus' | translate }}</mat-label>
                            <mat-select data-test="FS-Status wählen"
                                        [placeholder]="'workflows.screens.dockSiteOrder.statusPlaceholder' | translate"
                                        formControlName="status">
                                <mat-option *ngFor="let order of orderTypes" [value]="order">
                                    {{ order | translate }}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{formGroup.get('status').errors | firstErrorMessage}}</mat-error>
                        </mat-form-field>
                    </div>
                </mat-expansion-panel>

                <mat-expansion-panel [expanded]="step === 4" (opened)="setStep(4)" hideToggle>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ 'workflows.screens.dockSiteOrder.panelWorkPackages' | translate }}
                        </mat-panel-title>
                        <mat-panel-description>
                            <span fxHide.lt-sm>
                                <ng-container *ngIf="selectedWorkPackages?.length as wpCount; else wpHint">
                                    {{ wpCount === 1 ? ('workflows.screens.dockSiteOrder.workPackagesCountOne' | translate) : ('workflows.screens.dockSiteOrder.workPackagesCountMany' | translate: { count: wpCount }) }}
                                </ng-container>
                                <ng-template #wpHint>{{ 'workflows.screens.dockSiteOrder.workPackagesAddHint' | translate }}</ng-template>
                            </span>
                            <mat-icon
                                    [color]="this.formGroup.get('orderWorkPackagesForm').dirty ? 'accent' : 'primary'">
                                archive
                            </mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div class="mb-12" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px">

                        <mat-form-field fxFlex>
                            <mat-label>{{ 'workflows.screens.dockSiteOrder.workPackagesLabel' | translate }}</mat-label>
                            <mat-select data-test="FS-Arbeitspaket wählen" formControlName="orderWorkPackagesForm">
                                <mat-option *ngFor="let orderWorkPackage of this.orderWorkPackages"
                                            [value]="orderWorkPackage">
                                    {{orderWorkPackage.shortDescription}}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{formGroup.get('orderWorkPackagesForm').errors | firstErrorMessage}}</mat-error>
                        </mat-form-field>
                        <button data-test="B-Abbrechen" mat-button (click)="onClickAddWorkPackage()" type="button"
                                class="mat-accent" [matTooltip]="'workflows.screens.dockSiteOrder.addWorkPackageTooltip' | translate"
                                [matTooltipPosition]="'above'">
                            <mat-icon>add_circle</mat-icon>
                        </button>
                    </div>

                    <div>
                        <ng-container *ngFor="let selectedPackage of this.selectedWorkPackages">
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <mat-icon class="mr-16">archive</mat-icon>
                                    {{selectedPackage.shortDescription}}
                                </div>
                                <button type="button" mat-button color="warn"
                                        (click)="removeOrderWorkPackage(selectedPackage)"
                                        [matTooltip]="'workflows.screens.dockSiteOrder.removeWorkPackageTooltip' | translate" [matTooltipPosition]="'above'">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </ng-container>
                    </div>

                </mat-expansion-panel>


                <mat-expansion-panel [expanded]="step === 5" (opened)="setStep(5)" hideToggle>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ 'workflows.screens.dockSiteOrder.panelTodos' | translate }}
                        </mat-panel-title>
                        <mat-panel-description>
                            <span fxHide.lt-sm>
                                <ng-container *ngIf="formGroup.get('todos')['controls']?.length as tdCount; else tdHint">
                                    {{ tdCount === 1 ? ('workflows.screens.dockSiteOrder.todosCountOne' | translate) : ('workflows.screens.dockSiteOrder.todosCountMany' | translate: { count: tdCount }) }}
                                </ng-container>
                                <ng-template #tdHint>{{ 'workflows.screens.dockSiteOrder.todosAddHint' | translate }}</ng-template>
                            </span>
                            <mat-icon
                                    [color]="this.formGroup.get('todos')['controls']?.length  ? 'accent' : 'primary'">
                                assignment
                            </mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div>
                        <div>
                            <div formArrayName="todos"
                                 *ngIf="this.formGroup.get('todos')['controls']?.length; else noTodos">
                                <div cdkDropList (cdkDropListDropped)="drop($event, true)">
                                    <div *ngFor="let todo of this.formGroup.get('todos')['controls']; let l = index"
                                         [attr.data-test]="'C-ToDo ' + (l + 1)" [formGroupName]="l" fxLayout="row"
                                         fxLayoutAlign="space-between center" fxLayoutGap="24px" cdkDrag>
                                        <button type="button" class="drag-handle" mat-icon-button cdkDragHandle>
                                            <mat-icon>drag_indicator</mat-icon>
                                        </button>
                                        <mat-form-field appearance="outline" fxFlex="90">
                                            <mat-label>{{ 'workflows.screens.dockSiteOrder.todoFieldLabel' | translate }}</mat-label>
                                            <input matInput data-test="FI-ToDo" type="text" value="{{todo.todo}}"
                                                   formControlName="todo">
                                            <mat-error>{{todo.get('todo').errors | firstErrorMessage}}
                                            </mat-error>
                                        </mat-form-field>


                                        <div class="mb-8" fxFlex="10">
                                            <ng-container *hasPermission="BcmUserPermission.ORDERS_WRITE">
                                                <button hidden (click)="addTodoToOrderWorkPackage($event)"></button>

                                                <button data-test="B-ToDo entfernen" mat-button
                                                        [matTooltip]="'workflows.screens.dockSiteOrder.removeTodoTooltip' | translate" [matTooltipPosition]="'above'"
                                                        class="mat-error"
                                                        (click)="removeTodoFromOrderWorkPackage($event, l)">
                                                    <mat-icon>delete</mat-icon>
                                                </button>

                                            </ng-container>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div fxLayoutAlign="end end">
                                <button data-test="B-Abbrechen" mat-button
                                        (click)="addTodoToOrderWorkPackage($event)"
                                        type="button" class="mat-accent pr-0" [matTooltip]="'workflows.screens.dockSiteOrder.addTodoTooltip' | translate"
                                        [matTooltipPosition]="'above'">
                                    <mat-icon>add_circle</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <ng-template #noTodos>
                        <p>{{ 'workflows.screens.dockSiteOrder.noTodos' | translate }}</p>
                    </ng-template>
                </mat-expansion-panel>

                <mat-expansion-panel [expanded]="step === 6" (opened)="setStep(6)" hideToggle>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ 'workflows.screens.dockSiteOrder.panelServices' | translate }}
                        </mat-panel-title>
                        <mat-panel-description>
                            <span fxHide.lt-sm>
                                <ng-container *ngIf="formGroup.get('invoicePositions')['controls']?.length as ipCount; else ipHint">
                                    {{ ipCount === 1 ? ('workflows.screens.dockSiteOrder.servicesCountOne' | translate) : ('workflows.screens.dockSiteOrder.servicesCountMany' | translate: { count: ipCount }) }}
                                </ng-container>
                                <ng-template #ipHint>{{ 'workflows.screens.dockSiteOrder.servicesAddHint' | translate }}</ng-template>
                            </span>
                            <mat-icon
                                    [color]="this.formGroup.get('invoicePositions')['controls']?.length  ? 'accent' : 'primary'">
                                add_shopping_cart
                            </mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="12px">
                        <div fxFlex="100">
                            <div formArrayName="invoicePositions"
                                 *ngIf="this.formGroup.get('invoicePositions')['controls']?.length; else noInvoicePositions">
                                <div cdkDropList (cdkDropListDropped)="drop($event, false)">
                                    <div *ngFor="let invoicePosition of this.formGroup.get('invoicePositions')['controls']; let k = index"
                                         [attr.data-test]="'C-InvoicePosition ' + (k + 1)" [formGroupName]="k">
                                        <div fxFlex="60" fxLayout="row" fxLayoutAlign="space-between center"
                                             cdkDrag>
                                            <button type="button" class="drag-handle" mat-icon-button
                                                    cdkDragHandle>
                                                <mat-icon>drag_indicator</mat-icon>
                                            </button>
                                            <mat-form-field appearance="outline" floatLabel="always" fxFlex>
                                                <mat-label>{{ 'common.productSearchPlaceholder' | translate }}</mat-label>
                                                <input type="text" matInput data-test="FI-Produkte durchsuchen..."
                                                       value="{{ invoicePosition.get('product').value?.name }}"
                                                       formControlName="product"
                                                       [matAutocomplete]="productSelector">
                                                <mat-error>{{invoicePosition.get('product').errors | firstErrorMessage}}
                                                </mat-error>
                                            </mat-form-field>

                                            <mat-autocomplete #productSelector="matAutocomplete"
                                                              [displayWith]="displayProductWith">
                                                <mat-option *ngFor="let product of (filteredProducts$ | async)"
                                                            [value]="product">
                                                    <span>{{ product.name }}</span>
                                                    <small> | {{ product.price | bcmDynamicCurrency :
                                                            '1.2-4'}}</small>
                                                </mat-option>
                                            </mat-autocomplete>
                                        </div>

                                        <mat-form-field appearance="outline" fxFlex="30">
                                            <mat-label>{{ 'common.quantity' | translate }}</mat-label>
                                            <app-input-number matInput
                                                              [formControl]="invoicePosition.get('quantity')"
                                                              data-test="FI-Anzahl / Einheiten"
                                                              [step]="1"></app-input-number>
                                            <mat-error>{{invoicePosition.get('quantity').errors | firstErrorMessage}}
                                            </mat-error>
                                        </mat-form-field>


                                            <div fxFlex="10" fxLayoutAlign="center center">
                                                <ng-container *hasPermission="BcmUserPermission.ORDERS_WRITE">
                                                    <button hidden
                                                            (click)="addInvoicePositionToOrderWorkPackage($event)"></button>
                                                    <button data-test="B-ToDo entfernen" type="button" mat-button
                                                            [matTooltip]="'workflows.screens.dockSiteOrder.removeServiceTooltip' | translate"
                                                            [matTooltipPosition]="'above'"
                                                            class="mat-error"
                                                            (click)="removeInvoicePositionFromOrderWorkPackage($event, k)">
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>

                            </div>
                            <div fxLayoutAlign="end end">
                                <button data-test="B-Abbrechen" mat-button
                                        (click)="addInvoicePositionToOrderWorkPackage($event)" type="button"
                                        class="mat-accent pr-0" [matTooltip]="'workflows.screens.dockSiteOrder.addServiceTooltip' | translate"
                                        [matTooltipPosition]="'above'">
                                    <mat-icon>add_circle</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <ng-template #noInvoicePositions>
                        <p>{{ 'workflows.screens.dockSiteOrder.noServices' | translate }}</p>
                    </ng-template>
                </mat-expansion-panel>

                <mat-expansion-panel [expanded]="step === 7" (opened)="setStep(7)" hideToggle>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ 'workflows.screens.dockSiteOrder.panelAssignee' | translate }}
                        </mat-panel-title>
                        <mat-panel-description>
                            <span fxHide.lt-sm>
                                <ng-container *ngIf="formGroup.get('user').value as assignee; else pickAssignee">
                                    {{ assignee.user?.firstName }} {{ assignee.user?.lastName }}
                                </ng-container>
                                <ng-template #pickAssignee>{{ 'workflows.screens.dockSiteOrder.assigneeHint' | translate }}</ng-template>
                            </span>
                            <mat-icon [color]="this.formGroup.get('user').value  ? 'accent' : 'primary'">
                                person
                            </mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px">
                        <div fxFlex="100" fxLayoutGap="24px">
                            <mat-select data-test="FS-Bearbeiter wählen"
                                        [placeholder]="'workflows.screens.dockSiteOrder.assigneePlaceholder' | translate"
                                        formControlName="user" fxFlex="85">
                                <mat-option *ngFor="let user of this.users" [value]="user">
                                    {{user.user?.firstName}} {{ user.user?.lastName}}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>
                </mat-expansion-panel>

                <div class="mt-24">
                    <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
                        <mat-label>{{ 'common.notesOptional' | translate }}</mat-label>
                        <textarea matInput data-test="FT-Bemerkungen / Notizen" formControlName="note" rows="3"
                                  autocomplete="new-password"></textarea>
                        <mat-error>{{formGroup.get('note').errors | firstErrorMessage}}</mat-error>
                    </mat-form-field>
                </div>

                <mat-divider class="special-divider"></mat-divider>

                <ng-container
                        *ngIf="(formGroup.dirty && formGroup.invalid) || (formGroupPrepare.dirty && formGroupPrepare.invalid)">
                    <u2b-message type="warning" customClass="mt-24">
                        {{ 'workflows.shared.formInvalidHint' | translate }}
                    </u2b-message>
                </ng-container>

                <ng-container
                        *ngIf="(formGroup.dirty && formGroup.valid) && (formGroupPrepare.dirty && formGroupPrepare.valid)">
                    <u2b-message type="success" customClass="mt-24">
                        <header>{{ 'workflows.shared.formCompleteTitle' | translate }}</header>
                        {{ 'workflows.shared.formCompleteSaveHint' | translate }}
                    </u2b-message>
                </ng-container>

            </mat-accordion>
        </div>

        <div mat-dialog-actions class="m-0 p-8 p-sm-16" fxLayout="row" fxLayoutAlign="space-between center">

            <button data-test="B-Abbrechen" mat-flat-button (click)="onClickClose()" type="button">
                {{ 'common.cancel' | translate }}
            </button>

            <div>
                <ng-template #saving>
                    <mat-icon>save</mat-icon>
                    <span>{{ 'common.saving' | translate }}</span>
                    <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
                </ng-template>

                <ng-template #notSaving>
                    <mat-icon>save</mat-icon>
                    <span>{{ 'common.save' | translate }}</span>
                </ng-template>

                <button type="submit" data-test="B-Speichern" mat-flat-button color="accent" [disabled]="isSaving">
                    <ng-container *ngIf="isSaving; then saving else notSaving"></ng-container>
                </button>
            </div>

        </div>
    </form>
</div>
